import { passwordRequirements } from '../lib/password'
import { CheckCircleIcon } from './icons'

/**
 * Live checklist shown under a new-password field. Each rule ticks green the moment the typed
 * password satisfies it, so the person can see the requirements being fulfilled as they type. The
 * rules come from lib/password, the single source of truth shared with the submit-time guard.
 */
export function PasswordRequirements({ password, className = '' }: { password: string; className?: string }) {
  const rules = passwordRequirements(password)
  return (
    <ul className={`space-y-1 ${className}`} aria-label="Password requirements">
      {rules.map((r) => (
        <li
          key={r.id}
          className={`flex items-center gap-2 text-xs transition-colors ${
            r.met ? 'text-emerald' : 'text-[color:rgb(var(--muted))]'
          }`}
        >
          {r.met ? (
            <CheckCircleIcon className="h-3.5 w-3.5 shrink-0" />
          ) : (
            <span className="hairline h-3.5 w-3.5 shrink-0 rounded-full border" aria-hidden />
          )}
          <span>{r.label}</span>
          <span className="sr-only">{r.met ? ', met' : ', not met yet'}</span>
        </li>
      ))}
    </ul>
  )
}
